module.exports = __webpack_public_path__ + "img/setting.ddbfb19a.svg";